import { call, put, takeLatest } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { TeamActionTypes } from 'app/modules/teamsOld/models';

// Actions
import { retrieveAllTagsSuccess } from 'app/modules/teamsOld/actions';

// API
import { getAllTags } from 'app/shared/api/team';
import { FullTagResponse } from 'app/modules/tags/responses';

const rootAction = TeamActionTypes.RETRIEVE_ALL_TAGS;
export function* retrieveAllTags() {
  const config = {
    rootAction,
    request: call(getAllTags),
    success: function* onSuccess(result: FullTagResponse[]) {
      yield put(retrieveAllTagsSuccess(result));
    },
  };
  yield call(makeSagaRequest, config);
}

export default function* watchRetrieveAllTags() {
  yield takeLatest(rootAction, retrieveAllTags);
}
